/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// This file exists to allow the set of reactivity exports to be modified in g3, as these APIs are
// only "beta" for the time being.

export * from './core_reactivity_export_internal';
